import { TableCell } from '@mui/material';
import { minWidth, styled } from "@mui/system";

// smallセル
export const SmallCell = styled(TableCell)(({ theme }) =>({
    [theme.breakpoints.up("xs")]: {
        minWidth: '100px'
    },
    [theme.breakpoints.up("sm")]: {
        width: '6%'
    },

}))

// Mediumセル
export const MediumCell = styled(TableCell)(({ theme }) =>({
    [theme.breakpoints.up("xs")]: {
        minWidth: '150px'
    },
    [theme.breakpoints.up("sm")]: {
        width: '10%'
    },
}))

// Largeセル
export const LargeCell = styled(TableCell)(({ theme }) =>({
    [theme.breakpoints.up("xs")]: {
        minWidth: '200px'
    },
    [theme.breakpoints.up("sm")]: {
        width: '15%'
    },
}))

export const CheckboxCell = ({ children, sx = {}, ...props }) => (
  <TableCell align="center" sx={{ minWidth: 80, whiteSpace: 'nowrap', ...sx }} {...props}>
    {children}
  </TableCell>
);

export const ArrowCell = ({ children, sx = {}, ...props }) => (
  <TableCell align="center" sx={{ minWidth: 20, whiteSpace: 'nowrap', ...sx }} {...props}>
    {children}
  </TableCell>
);

export const WorkStepCell = ({ children, sx = {}, ...props }) => (
  <TableCell sx={{ minWidth: 100, whiteSpace: 'nowrap', ...sx }} {...props}>
    {children}
  </TableCell>
);